import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AuthForm from '../../components/AuthForm/AuthForm';

class AuthLogin extends Component {
  static propTypes = {
    login: PropTypes.func.isRequired,
    status: PropTypes.string.isRequired,
    error: PropTypes.string.isRequired,
    annulUserTokenError: PropTypes.func.isRequired,
    linkedinStatus: PropTypes.string.isRequired,
  }

  submitHandler = (data) => {
    this.props.login(data);
  }

  render() {
    const {
      status,
      error,
      annulUserTokenError,
      linkedinStatus,
    } = this.props;
    return (<AuthForm
      label="Log in"
      buttonLabel="Log in"
      type="login"
      annulError={annulUserTokenError}
      linkedinStatus={linkedinStatus}
      status={status}
      error={error}
      submitHandler={this.submitHandler}
      className="login-form"
    />);
  }
}

export default AuthLogin;



// WEBPACK FOOTER //
// ./src/containers/AuthLogin/AuthLogin.js